import { render, staticRenderFns } from "./SelectRole.vue?vue&type=template&id=f2f78612&scoped=true&"
import script from "./SelectRole.vue?vue&type=script&lang=js&"
export * from "./SelectRole.vue?vue&type=script&lang=js&"
import style0 from "./SelectRole.vue?vue&type=style&index=0&id=f2f78612&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f78612",
  null
  
)

export default component.exports